import { apiClient } from '@app/lib'
import { type SugarEnrollmentUpdate, type SugarEnrollmentUpdateResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUpdateEnrollment = () => {
  const queryClient = useQueryClient()
  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (input: SugarEnrollmentUpdate) => {
      const { data } = await apiClient.post<SugarEnrollmentUpdateResponse>('/api/enrollments', input)

      return data
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['enrollments']
      })
  })

  return {
    isUpdatingEnrollment: isPending,
    updateEnrollment: mutateAsync
  }
}
